import React from 'react'
import { Linking, Text } from 'react-native'
import { plainChatSpans, type ChatSpan } from '../../lib/chatText'
import { reportError } from '../../lib/reporting'

/** Inline native Text nodes, shared by game logs and public/private conversations. */
export function ChatMessageText({ content, spans, onOpenLink }: { content?: string; spans?: ChatSpan[]; onOpenLink?: (href: string) => boolean }) {
  const parsed = React.useMemo(() => spans ?? plainChatSpans(content ?? ''), [content, spans])
  return <>{parsed.map((span, index) => <Text key={index} className={span.author ? 'text-ink' : undefined} accessibilityRole={span.href ? 'link' : undefined}
    onPress={span.href ? event => {
      event.stopPropagation()
      if (!onOpenLink?.(span.href!)) void Linking.openURL(span.href!).catch(error => reportError(error, { tags: { area: 'chat-link' }, extra: { href: span.href } }))
    } : undefined}
    style={{ ...(span.bold ? { fontWeight: '700' } : {}), ...(span.href ? { textDecorationLine: 'underline' } : {}) }}>
    {span.text}
  </Text>)}</>
}
